import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiSparkles = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.7538 8.83566L6.0153 6.0153L8.83566 4.7538C8.97682 4.69073 9.03689 4.52853 8.97682 4.38737C8.94979 4.32429 8.89873 4.27623 8.83566 4.2462L6.0153 2.9847L4.7538 0.164345C4.69073 0.0231774 4.52853 -0.036894 4.38737 0.0231774C4.32429 0.0502095 4.27623 0.10127 4.2462 0.164345L2.9847 2.9847L0.164345 4.2462C0.0231774 4.30927 -0.036894 4.47147 0.0231774 4.61263C0.0502095 4.67571 0.10127 4.72377 0.164345 4.7538L2.9847 6.0153L4.2462 8.83566C4.30927 8.97682 4.47147 9.03689 4.61263 8.97682C4.67571 8.94979 4.72677 8.89873 4.7538 8.83566Z",
			fill: "url(#paint0_linear_12563_33579)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8418 8.30344L13.3401 7.32359L12.2199 5.12861C12.1656 5.01842 12.0196 4.97077 11.8941 5.01842C11.8397 5.03927 11.7956 5.07798 11.7685 5.12861L10.6483 7.32359L8.14659 8.30344C8.02099 8.35109 7.96668 8.47915 8.02099 8.58935C8.04475 8.637 8.08888 8.67572 8.14659 8.69954L10.6483 9.67939L11.7685 11.8714C11.8228 11.9816 11.9687 12.0292 12.0943 11.9816C12.1486 11.9607 12.1928 11.922 12.2199 11.8714L13.3401 9.67641L15.8418 8.69656C15.9674 8.65487 16.0319 8.53276 15.9844 8.42257C15.9606 8.36598 15.9097 8.3213 15.8418 8.30344Z",
			fill: "url(#paint1_linear_12563_33579)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.89077 12.83L8.01065 11.9894L7.17005 10.1092C7.12834 10.0162 7.01925 9.97447 6.92621 10.0162C6.8845 10.0354 6.85241 10.0675 6.83316 10.1092L5.98935 11.9894L4.10923 12.83C4.01618 12.8717 3.97447 12.9807 4.01618 13.0738C4.03543 13.1155 4.06752 13.1476 4.10923 13.1668L5.98935 14.0106L6.82995 15.8908C6.87166 15.9838 6.98075 16.0255 7.07379 15.9838C7.1155 15.9646 7.14759 15.9325 7.16684 15.8908L8.01065 14.0106L9.89077 13.17C9.98382 13.1283 10.0255 13.0193 9.98382 12.9262C9.96778 12.8845 9.93248 12.8492 9.89077 12.83Z",
			fill: "url(#paint2_linear_12563_33579)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_12563_33579",
				x1: 8.05946,
				y1: -8.85001,
				x2: -1.68826,
				y2: -7.46398,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#2214E4" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .52,
						stopColor: "#D696CE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#2F67FE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_12563_33579",
				x1: 15.164,
				y1: -1.88334,
				x2: 6.55158,
				y2: -.483798,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#2214E4" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .52,
						stopColor: "#D696CE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#2F67FE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_12563_33579",
				x1: 9.37297,
				y1: 4.09999,
				x2: 2.8745,
				y2: 5.02402,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#2214E4" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .52,
						stopColor: "#D696CE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#2F67FE"
					})
				]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAiSparkles);
export default ForwardRef;
